import NiceModal from '@ebay/nice-modal-react';
import "./DashboardEditor.css";
import '/src/components/UI/Button/IconButton/IconButton.css'
import { isClient } from "/src/utils/access";
import DashboardBlock from '../block/DashboardBlock/DashboardBlock';
import DashboardFormBlockModal from '../block/DashboardFormBlockModal/DashboardFormBlockModal';
import IconButton from "/src/components/UI/Button/IconButton/IconButton";
import useDashboards from "../../hooks/useDashboards"
import Storage from "/src/utils/storage";
import { useEffect } from 'react';
import  "/src/components/fireworks/firework.css";
function DashboardEditor({ data, access }) {

    const storage = Storage('session');
    const currentCompany = storage.get('company');
    const { dashboard, setUpDashboard } = useDashboards(data.dashboard.id);
    let nbDashboardSharedPrinted = 0;
    let companyAlreadyWrite = [];
    const showAddBlockModal = () => NiceModal.show(DashboardFormBlockModal, {
        dashboardChannel: data,
        bot: data.dashboard.bot,
        setBlock: setUpDashboard
    });

    const hasOneVariable = () => {
        return dashboard.blocks.find(block => block.variables.length > 0) ? true : false;
    }

    const getSharedValues = () => {
        return dashboard.channels.find(channel => channel.id == data.id).values_variables;
    }

    const getNbOfSameCompany = (company_id) => {
        return dashboard.channels.filter((obj) => obj.company_id === company_id).length
    }

    return (
        <>
            <div id="firework-container"></div>
            {
                !isClient(access) && data.origin == 2 && dashboard != null && dashboard.blocks.length > 0 && getNbOfSameCompany(currentCompany.id) < dashboard.channels.length &&
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <div className="dashboard_message"><i className="fas fa-info-circle" style={{ marginRight: "15px" }}></i>
                        Be careful, you are about to edit the structure of this dashboard.
                        <br />
                        Be aware that it is shared to other companies and will therefore impact the structure of their own dashboards. Here are the organizations :
                        <br />
                        {
                            dashboard.channels.map((channel, i) => {
                                if (channel.company_id != currentCompany.id && companyAlreadyWrite.includes(channel.company_id) == false) {
                                    nbDashboardSharedPrinted++;
                                    companyAlreadyWrite.push(channel.company_id);
                                    let count = getNbOfSameCompany(channel.company_id);
                                    return <span key={i} style={{ fontWeight: 'bold' }}> {channel.company? (nbDashboardSharedPrinted > 1 ? " | " : "") : ""} {channel.company?.name} {count > 1 ? "(" + count + ")" : ""}</span>;
                                }

                            })
                        }

                    </div>
                </div>
            }
            <br /><br />
            <div>
                {
                    dashboard != null &&
                    dashboard.blocks.map((block, i) => {
                        block.shared_values_variables = getSharedValues();
                        block.origin = data.origin;
                        block.dashboard_channel = data;
                        block.dashboard = dashboard;
                        return (
                            <DashboardBlock data={block} access={access} key={i} bot={dashboard.bot} modifyBlockAction={setUpDashboard} arrowPointedAdd={!hasOneVariable() && i == 0} index={{ current: i, max: dashboard.blocks.length }} />
                        )
                    })
                }
            </div>
            <br></br>
            {
                !isClient(access) && dashboard != null && dashboard.blocks.length > 0 &&
                <div className="divider div-transparent div-dot"></div>
            }
            {
                dashboard != null && dashboard.blocks.length <= 0 &&
                <>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <div className="dashboard_message informatif_message_dashboard">{!isClient(access) ? "You don't have any block for the moment... Just create a new block and let's go !" : "This dashboard is currently empty. Please, contact your administrator for more information."} </div>
                    </div>
                    {!isClient(access) &&
                        < div class="arrow_anim bounce">
                            <a class="fa fa-arrow-down fa-2x"></a>
                        </div>
                    }
                </>
            }

            {
                !isClient(access) &&
                <div style={{ paddingBottom: "5%" }}>
                    <div className="dashboard_add_block" style={{ marginTop: dashboard != null && dashboard.blocks.length > 0 ? '5%' : '1%' }} >
                        <IconButton className="main-iconButton profil_action main_add-button space_tableButton dashboard_button" icon="fas fa-plus" key={'buttonAddBlock'} onClick={() => showAddBlockModal()} />
                    </div>
                </div>
            }


        </>
    );
}

export default DashboardEditor;